import dayjs, { Dayjs } from "dayjs";
import { FilterValue } from "../../Filters/FilterValue";
import { SortType } from "../../SortType";

export interface SalesAnalyticsFilters {
  page: number;
  limit: number;
  search: string | null;
  sortBy: string;
  sortType: SortType;
  start_date: Dayjs;
  end_date: Dayjs;
  owner_ids?: FilterValue[];
  team_ids?: FilterValue[];
}

export interface SalesAnalyticsSelectedFilters {
  page: number;
  limit: number;
  search: string | null;
  sortBy: string;
  sortType: SortType;
  start_date: string;
  end_date: string;
  owner_ids?: FilterValue[];
  stage?: number;
  stagePage?: number;
  team_ids?: FilterValue[];
}

export function parseQueryParamsForSalesAnalyticsFilters(
  params: SalesAnalyticsFilters | null,
  query_params: URLSearchParams,
): SalesAnalyticsFilters {
  const currentDate = dayjs().startOf("day");
  const previousMonthDate = currentDate.startOf("month");

  const rawStartDate = query_params.get("start_date");
  const rawEndDate = query_params.get("end_date");
  return {
    page: params?.page ?? 1,
    limit: params?.limit ?? 30,
    search: params?.search ?? "",
    sortBy: params?.sortBy || "created_date",
    sortType: params?.sortType ?? SortType.DESC,
    start_date:
      rawStartDate && rawStartDate.trim() !== ""
        ? dayjs(rawStartDate, "YYYY-MM-DD")
        : previousMonthDate,
    end_date:
      rawEndDate && rawEndDate.trim() !== ""
        ? dayjs(rawEndDate, "YYYY-MM-DD")
        : currentDate,
    owner_ids: params?.owner_ids ?? [],
    team_ids: params?.team_ids ?? [],
  };
}
